import UnitySkill from "../Components/UnitySkill";
import BlenderSkill from "../Components/BlenderSkill";
import CSharpSkill from "../Components/CSharpSkill";
import CSSkill from "../Components/CSSSkill";
import HtmlSkill from "../Components/HTMLSkill";
import ReactSkill from "../Components/ReactSkill";

export default function Skills(){
    return (
        <div className="container">
            <h1>Skills</h1>
            <div className="skills">
                <UnitySkill/>
                <BlenderSkill/>
                <CSharpSkill/>
            </div>
            <div className="skills">
                <HtmlSkill/>
                <CSSkill/>
                <ReactSkill/>
            </div>
        </div>
    )
}